import { useLocalStorage } from "react-migration/lib/persistence/state/useLocalStorage";
import { useCallback, useMemo } from "react";

type ExistingPlanningSummary = {
  hasRecentSummary: boolean;
  recentSummaryMarkdown: string | null;
  setRecentSummaryForSite: (summary: string) => void;
};

export const useExistingPlanningSummary = ({ siteId }: { siteId?: string }): ExistingPlanningSummary => {
  const [recentSummary, setRecentSummary] = useLocalStorage<{ siteId: string; summary: string }[]>(
    "recent-planning-summaries",
    []
  );

  const recentSummaryForSite = useMemo(
    () => recentSummary?.find((summary) => summary.siteId === siteId) ?? null,
    [recentSummary, siteId]
  );

  const setRecentSummaryForSite = useCallback(
    (summary: string) => {
      if (!siteId) {
        return;
      }

      // Keep only the last 10 summaries for the site
      setRecentSummary((prev) => [...prev.filter((s) => s.siteId !== siteId), { siteId, summary }].slice(-10));
    },
    [siteId, setRecentSummary]
  );

  return {
    setRecentSummaryForSite,
    hasRecentSummary: !!recentSummaryForSite,
    recentSummaryMarkdown: recentSummaryForSite?.summary ?? null,
  };
};
